﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import KWDialog from './kw.dialog';

export default class KWBasketTile extends TKCustomElementFactory {
    url?: string;
    disabledClassName: string;

    constructor() {
        super();

        this.url = this.getAttribute('data-tk-url') || undefined;
        this.disabledClassName = this.getAttribute('data-tk-disabled-class-name') || 'tk-card--disabled';
    }

    connectedCallback(): void {
        if (!this.url) throw new Error('Basket-Tile: Url not defined!');
        this.registerClickListener();
    }

    registerClickListener() {
        const onClick = this.getDetailAsync.bind(this);
        this.pushListener({
            event: 'click',
            element: this,
            action: onClick,
        });
    }

    getDetailAsync(e:Event) {
        const targetElement = e.target as HTMLElement;
        if (targetElement.tagName === 'A') return;

        this.classList.add(this.disabledClassName);
        fetchRequest({
            requestURL: this.url!,
            resolveHandler: this.openDetail.bind(this),
        });
    }

    openDetail(response: TKResponse) {
        if (!response || !response.success) return;
        const dialog = KWDialog.renderDialog({
            tag: 'dialog',
            content: response.dataAsHtml,
            className: 'tk-dialog tk-dialog--fullscreen',
        });
        dialog.showModal();
        this.pushListener({
            event: 'close',
            element: dialog,
            action: this.removeTileDimmer.bind(this),
        });
    }

    removeTileDimmer() {
        this.classList.remove(this.disabledClassName);
    }
}